<template>
  <div v-loading="loading" element-loading-text="拼命加载中">
    <div class="info-box">
      <div class="title-box">
        <p>我的信息</p>
        <h5 class="iconfont icon-gengduo"></h5>
      </div>
      <div class="info-content">
        <div class="list-box">
          <div class="list-top">
            <template v-if="info.is_volunteer==1">
              <h5>{{info.number}}</h5>
            </template>
            <template v-else>
              <h5 @click="$router.push({name:'volunteerAdd'})">申请成为志愿者</h5>
            </template>
          </div>
          <div class="list-bottom">
            <p>
              <span style="background-color: #fb617f;"></span>志愿者编号
            </p>
          </div>
        </div>
        <div class="list-box">
          <div class="list-top">
            <p>
              {{info.total_service_length||0}}
              <span>h</span>
            </p>
          </div>
          <div class="list-bottom">
            <p>
              <span></span>服务时长
            </p>
          </div>
        </div>
        <div class="list-box">
          <div class="list-time">
            <p>
              {{info.volunteer_medal_num}}
              <span>个</span>
            </p>
          </div>
          <div class="list-bottom">
            <p>
              <span></span>荣誉勋章
            </p>
          </div>
        </div>
        <div class="list-box">
          <div class="list-time">
            <p>
              {{info.activity_apply_num}}
              <span>次</span>
            </p>
          </div>
          <div class="list-bottom">
            <p>
              <span style="background-color: #fb617f;"></span>活动参与
            </p>
          </div>
        </div>

        <div class="set-box">
          <div class="set-info">
            <h5>{{info.name||'暂未设置名称'}}</h5>
            <p class="iconfont icon-dianhua">{{info.mobile}}</p>
            <p class="iconfont icon-youxiang">{{info.email}}</p>
          </div>
          <div class="set-btn" @click="$router.push({name:'volunteerAdd'})">
            <h5 class="iconfont icon-shezhi"></h5>
            <p>设置</p>
          </div>
        </div>
      </div>
    </div>

    <div class="c-bottom">
      <div class="public-box">
        <div class="public-title">
          <p>活动足迹</p>
          <h5 class="iconfont icon-gengduo"></h5>
        </div>
        <!--获取用户的活动参与记录  3条-->
        <div class="train-box">
          <div class="train-top">
            <WtDataList
              v-model="activityApplyList"
              :url="$url.activity.apply.user"
              :pageSize="3"
              :isPage="false"
              ref="activityRef"
            >
              <div slot="list">
                <ul class="activity_ul">
                  <li v-for="(item,index) in activityApplyList" :key="index">
                    <div class="left-box">
                      <h5>{{getDate(item.created_at,'MD')}}</h5>
                      <p>{{getDate(item.created_at,'Y')}}</p>
                    </div>
                    <div class="right-box">
                      <h5>{{item.activity_name}}</h5>
                      <p>活动地点：{{item.province_text+item.city_text+item.country_text}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </WtDataList>
          </div>
        </div>
      </div>
      <div class="public-box">
        <div class="public-title">
          <p>荣誉勋章</p>
          <h5 class="iconfont icon-gengduo"></h5>
        </div>
        <div class="train-box">
          <WtDataList
            v-model="medalsList"
            :url="$url.medals.volunteer"
            :pageSize="4"
            :isPage="false"
            ref="medalsRef"
          >
            <div class="term-box" slot="list">
              <ul>
                <li v-for="(item,index) in medalsList" :key="index">
                  <p>{{dateFormat(item.created_at,'MM-dd')}}</p>
                  <div class="score-box">
                    <h5>获得 {{item.medal_name}}</h5>
                    <p>
                      <span class="iconfont icon-xingxing"></span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </WtDataList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      medalsList: {},
      loading: true,
      info: {},
      activityApplyList: [],
      navStatus: 1,
      termList: [
        {
          id: 1,
          name: "获得优秀志愿者勋章"
        },
        {
          id: 1,
          name: "获得优秀志愿者勋章"
        },
        {
          id: 1,
          name: "获得优秀志愿者勋章"
        },
        {
          id: 1,
          name: "获得优秀志愿者勋章"
        }
      ]
    };
  },
  methods: {
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    getDate(date, format = "M") {
      switch (format) {
        case "Y": {
          return date.substring(0, 4);
          break;
        }
        case "M": {
          return date.substring(5, 7);
          break;
        }
        case "D": {
          return date.substring(8, 10);
          break;
        }
        default: {
          return date.substring(5, 10);
          break;
        }
      }
    }
  },
  mounted() {
    //查询用户相关信息 (志愿者编号、服务时长、荣誉勋章、活动参与次数、个人信息)
    this.$db.get(this.$url.user.url).then(resp => {
      this.info = resp.data;
      this.loading = false;
    });
  }
};
</script>


<style lang="scss" scoped>
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 20px;
      line-height: 24px;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 20px;
      line-height: 20px;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    padding-bottom: 4.351851851851852vh;
    .list-box {
      height: 19.518518518518517vh;
      width: 11.5vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      .list-time {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        overflow: hidden;
        > p {
          color: #414c60;
          font-size: 30px;
          text-align: center;
          margin-top: 4.814814814814815vh;
          > span {
            color: #414c60;
            font-size: 16px;
            line-height: 20px;
          }
        }
        > i {
          display: block;
          width: 100%;
          font-style: normal;
          color: #8d95a4;
          font-size: 14px;
          // margin-top: 0.7259259259259259vh;
          text-align: center;
        }
      }
      .list-top {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        > p {
          color: #414c60;
          font-size: 30px;
          line-height: 13.796296296296295vh;
          text-align: center;

          > span {
            color: #414c60;
            font-size: 16px;
            line-height: 16px;
          }
        }
        > h5 {
          cursor: pointer;
          font-weight: normal;
          color: #414c60;
          font-size: 20px;
          line-height: 13.796296296296295vh;
          text-align: center;
        }
      }
      .list-bottom {
        height: 4.6296296296296294vh;
        position: relative;
        > p {
          color: #8d95a4;
          font-size: 13px;
          line-height: 16px;
          padding-left: 0.7291666666666667vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1caee0;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
    .set-box {
      height: 19.518518518518517vh;
      width: 30.833333333333335vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 3vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 20px;
          line-height: 20px;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 16px;
          line-height: 16px;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        cursor: pointer;
        > h5 {
          font-weight: normal;
          font-size: 30px;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 16px;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
.c-bottom {
  display: flex;
  justify-content: space-between;
  .public-box {
    width: 38.54166666666667vw;
    padding-bottom: 6.066666666666667vh;
    .public-title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      > p {
        color: #414c60;
        font-size: 20px;
        line-height: 20px;
      }
      > h5 {
        font-weight: normal;
        color: #8d95a4;
        font-size: 20px;
        line-height: 20px;
      }
    }
    .train-box {
      width: 100%;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      margin-top: 16px;
      border: solid 1px #e6e7eb;
      overflow: hidden;
      .train-top {
        width: 100%;
        height: 34.16666666666667vh;
      }
      .term-box {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          li {
            list-style: none;
            display: flex;
            margin-bottom: 5vh;
            &:last-child {
              margin-bottom: 0;
            }
            > p {
              width: 4.0625vw;
              height: 2.3148148148148147vh;
              border-right: 1px solid #e4e5e9;
              font-size: 20px;
              line-height: 2.3148148148148147vh;
              color: #bfc0c8;
            }
            .score-box {
              width: 29.635416666666664vw;
              display: flex;
              justify-content: space-between;
              padding-left: 1.3020833333333334vw;
              > h5 {
                color: #414c60;
                font-size: 16px;
                line-height: 2.3148148148148147vh;
              }
              > p {
                > span {
                  font-size: 2.3666666666666666vh;
                  line-height: 2.3148148148148147vh;
                  color: #414c60;
                }
              }
            }
          }
        }
      }
      .train-bottom {
        height: 10.092592592592593vh;
        background-color: #1caee0;
        position: relative;
        > p {
          font-size: 20px;
          color: #fff;
          font-weight: 600;
          padding-left: 3.4895833333333334vw;
          line-height: 4.6296296296296294vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #1caee0;
            font-size: 4.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
          > i {
            font-style: normal;
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #feb64d;
            font-size: 20px;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
        }
      }
    }
  }
}
.activity_ul {
  padding: 4.6296296296296294vh 2.1875vw;
  > li {
    list-style: none;
    display: flex;
    margin-bottom: 5.3703703703703705vh;
    &:last-child {
      margin-bottom: 0;
    }
    .left-box {
      height: 4.4444444444444446vh;
      width: 5vw;
      border-right: 1px solid #e4e5e9;
      > h5 {
        font-weight: normal;
        color: #bfc0c8;
        font-size: 2.7777777777777776vh;
        line-height: 2.7777777777777776vh;
      }
      > p {
        font-size: 16px;
        color: #bfc0c8;
      }
    }
    .right-box {
      padding-left: 1.5625vw;
      width: 26.666666666666666vw;
      > h5 {
        color: #414c60;
        font-size: 16px;
        line-height: 16px;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
        margin-bottom: 1.0037037037037037vh;
      }
      > p {
        color: #8d95a4;
        font-size: 1.2962962962962963vh;
        // line-height: 1.2962962962962963vh;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
    }
  }
}
.nodata {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.nodata img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/home/index.vue